import React from 'react';

export default function Header() {
    return (
        <header>
            <center>
                <h2>React Expense Tracker </h2>
            </center>
        </header>
    )
}
